import { InputGroup, TextArea } from '@blueprintjs/core';
import { lookupListItemApi } from 'api/lookuplistitemApi';
import Clearfix from 'components/elements/clearfix';
import IconRequired from 'components/elements/required-icon';
import SelectCategory from 'components/elements/select-category';
import Upload from 'components/elements/upload-file';
import { LOOKUP_IDS } from 'constants/lookup-list';
import { FIELDS } from 'containers/FacilityHazarWasteReportContainer/constants';
import { createForm } from 'rc-form';
import React from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

class AttachmentFormContainer extends React.Component {
  setInitialValue(keyPath, defaultValue) {
    let value = _.result(this.props.initialValue, keyPath, defaultValue);
    if (!value) value = defaultValue;
    return value;
  }

  onSuccessUpload = (res) => {
    if (res) {
      this.props.form.setFieldsValue({
        file: res,
      });
    }
  };

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    let selItem = _.result(this.props.initialValue, keyPath);
    if (!selItem) return defaultValue;
    return {
      value: selItem._id,
      label: nameLabel ? selItem[nameLabel] : selItem.Name,
    };
  }

  getLoaiFile = () => {
    return lookupListItemApi.getCategory(LOOKUP_IDS.LoaiFileDinhKemCTNH, {
      ProvinceId: 2,
    });
  };

  getHinhThucXuLy = () => {
    return lookupListItemApi.getCategory(LOOKUP_IDS.HinhThucXuLyCTNH, {
      ProvinceId: 2,
    });
  };

  render() {
    const { getFieldError, getFieldProps } = this.props.form;
    return (
      <div style={{ width: '100%' }}>
        <Row>
          <Col xs={3}>
            <LabelContainer>
              Tên hồ sơ
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={5}>
            <InputGroup
              placeholder='Tên báo cáo'
              {...getFieldProps('Title', {
                initialValue: this.setInitialValue('Title', ''),
                rules: [
                  {
                    required: true,
                    message: 'Trường này không được bỏ trống',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('Title') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={3}>
            <LabelContainer>Loại</LabelContainer>
          </Col>
          <Col xs={5}>
            <SelectCategory
              getCategory={this.getLoaiFile}
              name={FIELDS.attachmentType}
              getFieldProps={this.props.form.getFieldProps}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={3}>
            <LabelContainer>
              File đính kèm <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={5}>
            <Upload
              {...getFieldProps('file', {
                rules: [
                  {
                    required: true,
                    message: 'Cần đính kèm file',
                  },
                ],
              })}
              onSuccess={this.onSuccessUpload}
            />
            <ErrorContainer>
              {(getFieldError('file') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={3}>
            <LabelContainer>Chú thích</LabelContainer>
          </Col>
          <Col xs={5}>
            <TextArea
              fill
              placeholder='Chú thích'
              {...getFieldProps('Description', {
                initialValue: this.setInitialValue('Description', ''),
              })}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default createForm()(AttachmentFormContainer);



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportView/Attachment/AttachmentForm/index.js